<template>
<div>
    <div class="title222">
        <van-sticky offset-top="-0.9rem">
            <van-cell :title="'选择日期：' + costDateTitle" @click="costDateShow = true" class="costDateSel" />
            <van-calendar v-model="costDateShow" type="range" :allow-same-day="true" :show-confirm="false" @confirm="dateConfirm" :min-date="minDate" :max-date="maxDate" />
            <van-tabs v-model="active" @change="activeChange" background="#20a0ff" title-active-color="#fff" title-inactive-color="#3c3c45" style="height:1.17333rem;">
                <van-tab title="项目" name="project"></van-tab>
                <van-tab title="项目分类" name="category" v-if="user.companyId != '1071'"></van-tab>
                <van-tab title="部门" name="dept"></van-tab>
                <van-tab title="人员" name="user"></van-tab>
            </van-tabs>
        </van-sticky>
    </div>
    <div style="padding-top:2px;margin-bottom:1.33333rem">
            <van-cell v-if="listLoading" style="padding-top:2px;background-color: transparent;">
                <template #default>
                    <van-loading color="#1989fa" size="24" text-size="12" style="text-align:center;">加载中...</van-loading>
                </template>
            </van-cell>
            <van-cell v-if="!listLoading && displayList.length == 0" style="padding-top:2px;background-color: transparent;">
                <template #default>
                    <div style="text-align:center;color:#7d7e80;font-size:13px">暂无数据</div>
                </template>
            </van-cell>
            <template v-else-if="!listLoading">
                <div class="stat-card" v-for="(item, index) in displayList" :key="itemKey(item, index)" @click="onItemClick(item)">
                    <div class="stat-row">
                        <span class="stat-label">{{ firstLabel }}</span>
                        <span class="stat-value">{{ firstValue(item) }}</span>
                    </div>
                    <div v-if="active === 'project'" class="stat-row">
                        <span class="stat-label">项目编号</span>
                        <span class="stat-value">{{ item.projectCode || '-' }}</span>
                    </div>
                    <div class="stat-metrics">
                        <div v-if="countHours" class="stat-metric stat-metric--hours">
                            <span class="stat-label">工时</span>
                            <span class="stat-value">{{ formatHour(item) }} h</span>
                        </div>
                        <div v-if="countCost" class="stat-metric stat-metric--cost">
                            <span class="stat-label">成本</span>
                            <span class="stat-value">¥ {{ formatMoney(item) }}</span>
                        </div>
                    </div>
                </div>
            </template>
    </div>

    <van-popup v-model="drillShow" position="right" :style="{ width: '100%', height: '100%' }">
        <van-nav-bar :title="drillTitle" left-text="返回" left-arrow @click-left="drillBack" />
        <div class="drill-crumb">{{ drillCrumb }}</div>
        <van-loading v-if="drillLoading" color="#1989fa" size="24" style="display:block;text-align:center;padding:20px;">加载中...</van-loading>
        <template v-else>
            <div class="stat-card" v-for="(item, index) in drillRows" :key="'d'+index" @click="onDrillClick(item)">
                <div class="stat-row">
                    <span class="stat-label">{{ drillLabel }}</span>
                    <span class="stat-value">{{ drillName(item) }}</span>
                </div>
                <div class="stat-metrics">
                    <div v-if="countHours" class="stat-metric stat-metric--hours">
                        <span class="stat-label">工时</span>
                        <span class="stat-value">{{ formatHour(item) }} h</span>
                    </div>
                    <div v-if="countCost" class="stat-metric stat-metric--cost">
                        <span class="stat-label">成本</span>
                        <span class="stat-value">¥ {{ formatMoney(item) }}</span>
                    </div>
                </div>
            </div>
            <van-empty v-if="drillRows.length === 0" description="暂无数据" />
        </template>
    </van-popup>
    
    <Footer page="cost"></Footer>
</div>
</template>

<script>
import Footer from "@/components/Footer";
export default {
    components: {
        Footer
    },
    data() {
        return {
            countCost: false,
            countHours: false,
            active: 'project',
            listLoading: false,
            minDate: new Date(2020,0,1),
            maxDate: new Date(),
            costDateTitle: '',
            costDate: [],
            costDateShow: false,
            timeCostList: [],
            user: JSON.parse(localStorage.userInfo),

            drillShow: false,
            drillLoading: false,
            drillView: 'dept',
            drillStack: [],
            drillRows: [],
            currentUserName: ''
        }
    },
    computed: {
        displayList() {
            return this.timeCostList || []
        },
        firstLabel() {
            if (this.active === 'category') return '分类名称'
            if (this.active === 'dept') return '部门名称'
            if (this.active === 'user') return '姓名'
            return '项目名称'
        },
        drillTitle() {
            if (this.drillView === 'user') return '人员工时'
            if (this.drillView === 'project') return '项目工时'
            return '部门工时'
        },
        drillLabel() {
            if (this.drillView === 'user') return '姓名'
            if (this.drillView === 'project') return '项目'
            return '部门名称'
        },
        drillCrumb() {
            const parts = this.drillStack.map(item => item.name)
            if (this.drillView === 'project' && this.currentUserName) {
                parts.push(this.currentUserName)
            }
            return parts.join(' / ') || this.costDateTitle
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.userInfo)
        for(let i in user.functionList){
            if(user.functionList[i].name == '查看工时统计'){
                this.countHours = true
            }
            if(user.functionList[i].name == '查看成本统计'){
                this.countCost = true
            }
        }
        if (!this.countHours && !this.countCost) {
            this.countHours = true
            this.countCost = true
        }
        let end = new Date()
        this.maxDate = end
        let start = new Date(end.getFullYear(),end.getMonth(),1)
        this.costDate = [this.formatDate(start),this.formatDate(end)]
        this.costDateTitle = this.dateToTitle(this.costDate)
        this.getTimeCost()
    },
    methods: {
        formatDate(date) {
            let mon = date.getMonth() + 1
            return `${date.getFullYear()}-${mon<10?'0'+mon:mon}-${date.getDate()<10?'0'+date.getDate():date.getDate()}`;
        },
        dateToTitle(dateArr){
            let start = dateArr[0].split('-')
            let end = dateArr[1].split('-')
            return `${start[0]}年${start[1]}月${start[2]}日\u3000至\u3000${end[0]}年${end[1]}月${end[2]}日`
        },
        formatHour(item) {
            const value = item.costTime != null ? item.costTime : (item.cost != null ? item.cost : (item.time != null ? item.time : (item.hours != null ? item.hours : 0)))
            return Number(value || 0).toFixed(1)
        },
        formatMoney(item) {
            const value = item.costMoney != null ? item.costMoney : (item.money != null ? item.money : 0)
            return Number(value || 0).toFixed(2)
        },
        firstValue(item) {
            if (this.active === 'category') return item.categoryName || '-'
            if (this.active === 'dept') return item.departmentName || '-'
            if (this.active === 'user') return item.name || '-'
            return item.project || '-'
        },
        itemKey(item, index) {
            return item.departmentId || item.id || item.category || item.name || index
        },
        activeChange(){
            this.timeCostList = []
            this.getTimeCost()
        },
        dateConfirm(value){
            this.costDate = [this.formatDate(value[0]),this.formatDate(value[1])]
            this.costDateTitle = this.dateToTitle(this.costDate)
            this.costDateShow = false
            this.getTimeCost()
        },
        getTimeCost(){
            if (this.active === 'dept') {
                this.loadDeptList(null, true)
                return
            }
            if (this.active === 'user') {
                this.loadUserList(null, true)
                return
            }
            let url = this.active === 'category' ? '/project/getTimeCostByCategory' : '/project/getTimeCost'
            this.listLoading = true
            this.$axios.post(url, {
                startDate: this.costDate[0],
                endDate: this.costDate[1],
                type: 0
            }).then(res => {
                this.listLoading = false
                if(res.code == "ok") {
                    this.timeCostList = (res.data && res.data.costList) || []
                } else {
                    this.$toast.fail(res.msg || '获取失败');
                }
            }).catch(() => {this.listLoading = false;this.$toast.fail('获取失败')});
        },
        loadDeptList(parentDeptId, asMain) {
            if (asMain) {
                this.listLoading = true
            } else {
                this.drillLoading = true
                this.drillView = 'dept'
            }
            const parameter = {
                startDate: this.costDate[0],
                endDate: this.costDate[1]
            }
            if (parentDeptId) {
                parameter.parentDeptId = parentDeptId
            }
            this.$axios.post('/department/departmentStatistic', parameter).then(res => {
                if (asMain) {
                    this.listLoading = false
                } else {
                    this.drillLoading = false
                }
                if (res.code == 'ok') {
                    const list = (res.data && res.data.costList) || []
                    if (!asMain && parentDeptId && list.length === 0) {
                        this.loadUserList(parentDeptId, false)
                        return
                    }
                    if (asMain) {
                        this.timeCostList = list
                    } else {
                        this.drillRows = list
                    }
                } else {
                    this.$toast.fail(res.msg || '获取部门失败')
                }
            }).catch(() => {
                if (asMain) {
                    this.listLoading = false
                } else {
                    this.drillLoading = false
                }
                this.$toast.fail('获取部门失败')
            })
        },
        loadUserList(departmentId, asMain) {
            if (asMain) {
                this.listLoading = true
            } else {
                this.drillLoading = true
                this.drillView = 'user'
            }
            const parameter = {
                startDate: this.costDate[0],
                endDate: this.costDate[1]
            }
            if (departmentId) {
                parameter.departmentId = departmentId
            }
            this.$axios.post('/department/userStatistic', parameter).then(res => {
                if (asMain) {
                    this.listLoading = false
                } else {
                    this.drillLoading = false
                }
                if (res.code == 'ok') {
                    const list = (res.data && res.data.list) || []
                    const rows = list.map((item, index) => {
                        const projects = item.project || []
                        const hours = projects.reduce((sum, row) => sum + Number(row.time || 0), 0)
                        const money = projects.reduce((sum, row) => sum + Number(row.money || 0), 0)
                        return {
                            id: item.id || (item.name + index),
                            name: item.name,
                            project: projects,
                            hours: hours,
                            money: money,
                            costTime: hours,
                            costMoney: money
                        }
                    })
                    if (asMain) {
                        this.timeCostList = rows
                    } else {
                        this.drillRows = rows
                    }
                } else {
                    this.$toast.fail(res.msg || '获取人员失败')
                }
            }).catch(() => {
                if (asMain) {
                    this.listLoading = false
                } else {
                    this.drillLoading = false
                }
                this.$toast.fail('获取人员失败')
            })
        },
        onItemClick(item) {
            if (this.active === 'dept') {
                this.drillShow = true
                this.drillStack = [{ id: item.departmentId, name: item.departmentName, type: 'dept' }]
                if (item.hasSubDept) {
                    this.loadDeptList(item.departmentId, false)
                } else {
                    this.loadUserList(item.departmentId, false)
                }
                return
            }
            if (this.active === 'user') {
                this.drillShow = true
                this.drillStack = []
                this.currentUserName = item.name
                this.drillView = 'project'
                this.drillRows = (item.project || []).map(row => ({
                    project: row.project,
                    time: row.time,
                    money: row.money,
                    costTime: row.time,
                    costMoney: row.money
                }))
            }
        },
        onDrillClick(item) {
            if (this.drillView === 'dept') {
                this.drillStack.push({ id: item.departmentId, name: item.departmentName, type: 'dept' })
                if (item.hasSubDept) {
                    this.loadDeptList(item.departmentId, false)
                } else {
                    this.loadUserList(item.departmentId, false)
                }
                return
            }
            if (this.drillView === 'user') {
                this.currentUserName = item.name
                this.drillView = 'project'
                this.drillRows = (item.project || []).map(row => ({
                    project: row.project,
                    time: row.time,
                    money: row.money,
                    costTime: row.time,
                    costMoney: row.money
                }))
            }
        },
        drillName(item) {
            if (this.drillView === 'user') return item.name || '-'
            if (this.drillView === 'project') return item.project || '未命名项目'
            return item.departmentName || '-'
        },
        drillBack() {
            if (this.drillView === 'project') {
                this.drillView = 'user'
                this.currentUserName = ''
                if (!this.drillStack.length) {
                    this.drillShow = false
                    return
                }
                const parent = this.drillStack[this.drillStack.length - 1]
                this.loadUserList(parent.id, false)
                return
            }
            if (!this.drillStack.length) {
                this.drillShow = false
                return
            }
            this.drillStack.pop()
            if (!this.drillStack.length) {
                this.drillShow = false
                return
            }
            const parent = this.drillStack[this.drillStack.length - 1]
            this.loadDeptList(parent.id, false)
        }
    },
}
</script>

<style>
.title222 {
    background-color: #20a0ff;
    overflow: hidden;
}
.costDateSel {
    background-color: #20a0ff;
    color: #fff;
    font-size: 12px !important;
    padding-top: 0.14rem;
    padding-left: 0.43rem;
    padding-bottom: 0.3rem;
    height: 1.08rem;
}
.costDateSel::after{
    display: none;
}
.title222 .van-tabs__line{
    background-color: #f7f7f7;
}
.stat-card {
    margin: 8px 12px 0;
    padding: 12px;
    background: #fff;
    border-radius: 4px;
}
.stat-row {
    display: flex;
    align-items: flex-start;
    line-height: 1.6;
}
.stat-row + .stat-row {
    margin-top: 4px;
}
.stat-label {
    flex: 0 0 72px;
    color: #969799;
    font-size: 13px;
}
.stat-value {
    flex: 1;
    min-width: 0;
    color: #323233;
    font-size: 14px;
    word-break: break-all;
}
.stat-metrics {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    gap: 8px;
}
.stat-metric {
    display: flex;
    align-items: center;
    line-height: 1.6;
    min-width: 0;
}
.stat-metric--hours .stat-label {
    flex: 0 0 72px;
}
.stat-metric--hours .stat-value {
    flex: none;
}
.stat-metric--cost {
    flex-shrink: 0;
    margin-left: auto;
}
.stat-metric--cost .stat-label {
    flex: none;
    width: auto;
    margin-right: 8px;
}
.stat-metric--cost .stat-value {
    flex: none;
    white-space: nowrap;
}
.drill-crumb {
    padding: 10px 16px;
    color: #666;
    font-size: 13px;
    background: #f7f8fa;
}
</style>
